/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Header from "./header"
import "./layout.css"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Header siteTitle={data.site.siteMetadata?.title || `Title`} />
        <main>{children}</main>
        <footer>
          <div className="footer-left">
            <StaticImage 
              src="../images/Alice.png"
              quality={100}
              alt="Wicked Alice"
              class="alice-img"
            ></StaticImage>
          </div>
          <div className = "footer-center">
            <a href="https://wickedwitchworld.com/" className="footer-link">Copyright © 2021. All rights reserved by witchesNFT</a>
          </div>
          <div className="footer-right">
            <a href="https://twitter.com/witchesNFT" className="footer-link">Twitter</a>
            <a href="https://discord.gg/Az6zgVZwZf" className="footer-link">Discord</a>
            <a href="https://opensea.io/collection/witchesnft" className="footer-link">Opensea Collection</a>
            <a href="https://etherscan.io/token/0xf2a0f5102801e94090c4dac23bc640b61dd75b6b" className="footer-link">Etherscan</a>

          </div>
        </footer>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
